export const tableViagemSearhClientColumns = ["Nome", "Documento", "Endereço", ""]